import { TypographyH2 } from "@/components/ui/typography"
import { useApplyPromoCodeForm } from "./model"
import { Input } from "@/components/ui/input"
import { Controller } from "react-hook-form"
import { InputGroup, InputGroupError } from "@/components/ui/input-group"
import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"
import { useAutoTranslation } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS, LANG_KEYS } from "@/shared/constants"

export const ApplyPromoCodeForm = () => {
  const { t } = useAutoTranslation()
  const { control, handleSubmit, isLoading, codeValue, formError } =
    useApplyPromoCodeForm()

  return (
    <form onSubmit={handleSubmit}>
      <TypographyH2>
        🎁{" "}
        {t(LANG_KEYS.ENTER_YOUR_CODE_TO_UNLOCK_SPECIAL_FEATURES_OR_DISCOUNTS)}
      </TypographyH2>

      <Controller
        control={control}
        name="code"
        render={({ field }) => (
          <InputGroup className="my-6 flex gap-2 p-2 pr-0">
            <Label htmlFor="promo-code" className="whitespace-nowrap">
              {t(DISCOVERED_TRANSLATION_KEYS.PROMO_CODE)}
            </Label>
            <Input
              id="promo-code"
              type="text"
              value={field.value}
              onChange={field.onChange}
              aria-invalid={!!formError}
            />
            <InputGroupError>{formError}</InputGroupError>
          </InputGroup>
        )}
      />

      <Button type="submit" isLoading={isLoading} disabled={!codeValue.trim()}>
        {t(LANG_KEYS.APPLY)}
      </Button>
    </form>
  )
}
